import { z } from 'zod/v4'
import createComponentSchema from '../util/createComponentSchema'

const publicButtonShape = z.object({
  type: z.literal('public'),
  link: z
    .object({
      url: z.string(),
      target: z.string().optional()
    })
    .optional(),
  label: z.string().optional()
})

const HeroBannerSecondarySchema = createComponentSchema(
  'HeroBannerSecondary',
  z.object({
    des: z.string(),
    complement: z.string(),
    leftBackgroundImageUrl: z.string().optional(),
    rightBackgroundImageUrl: z.string().optional(),
    anchorIdentifier: z.string().optional(),
    button: z.union([publicButtonShape]).optional()
  })
)

export default HeroBannerSecondarySchema
